import { cn } from "@/lib/utils"

interface AudioWaveformProps {
  isPlaying: boolean
  className?: string
}

export function AudioWaveform({ isPlaying, className }: AudioWaveformProps) {
  return (
    <div className={cn("flex items-center gap-0.5 h-4", className)}>
      {[...Array(5)].map((_, i) => (
        <div
          key={i}
          className={cn(
            "w-1 rounded-full bg-primary transition-all duration-150",
            isPlaying
              ? "animate-[waveform_0.5s_ease-in-out_infinite]"
              : "h-1"
          )}
          style={{
            animationDelay: isPlaying ? `${i * 0.1}s` : undefined,
          }}
        />
      ))}
    </div>
  )
}
